import { render, staticRenderFns } from "./ServicesTermsAndConditions.vue?vue&type=template&id=71a7937c&"
import script from "./ServicesTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./ServicesTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports